import { render, staticRenderFns } from "./boost-user.vue?vue&type=template&id=4f86b988&"
import script from "./boost-user.vue?vue&type=script&lang=js&"
export * from "./boost-user.vue?vue&type=script&lang=js&"
import style0 from "./boost-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports